"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.initialState = void 0;
var action_1 = require("./action");
exports.initialState = {};
function reducer(state, action) {
    var _a;
    if (state === void 0) { state = exports.initialState; }
    switch (action.type) {
        case action_1.START: {
            return merge(state, action.payload.key, { isLoading: true, isLoaded: false });
        }
        case action_1.FINISH: {
            return merge(state, action.payload.key, { isLoading: false, isLoaded: true });
        }
        case action_1.FAIL: {
            var errors = ((_a = state[action.payload.key]) === null || _a === void 0 ? void 0 : _a.errors) || [];
            return merge(state, action.payload.key, {
                isLoading: false,
                isLoaded: true,
                errors: errors.concat(action.payload.error),
            });
        }
        case action_1.RESET: {
            return {};
        }
        default: {
            var _1 = action;
            return state;
        }
    }
}
exports.reducer = reducer;
var merge = function (state, key, item) {
    var _a;
    return (__assign(__assign({}, state), (_a = {}, _a[key] = __assign(__assign({}, (state[key] || {
        id: "",
        isLoading: false,
        isLoaded: false,
        errors: [],
    })), item), _a)));
};
